<div [class]="alignment === 'center' ? 'text-center' : 'text-center lg:text-left'">
  @if (heading) {
    <h1
      class="mb-4 font-accent font-light text-2xl"
      [style.color]="iconColor | contentBuilderColor: 'primary-600'"
    >
      {{ heading }}
    </h1>
  }
  <div
    [class]="
      alignment === 'center'
        ? 'flex justify-center pb-8'
        : 'flex justify-center lg:justify-start pb-8'
    "
  >
    @if (facebookLink) {
      <div class="mr-2">
        <app-rounded-icon-button
          [size]="'sm'"
          [dimension]="iconSizeCss"
          [type]="'without-background'"
          icon="icon-facebook"
          [overrideColor]="iconColor"
          (click)="navigateTo(facebookLink)"
        ></app-rounded-icon-button>
      </div>
    }
    @if (twitterLink) {
      <div class="mr-2">
        <app-rounded-icon-button
          [size]="'sm'"
          [dimension]="iconSizeCss"
          [type]="'without-background'"
          icon="icon-x"
          [overrideColor]="iconColor"
          (click)="navigateTo(twitterLink)"
        ></app-rounded-icon-button>
      </div>
    }
    @if (linkedinLink) {
      <div class="mr-2">
        <app-rounded-icon-button
          [size]="'sm'"
          [dimension]="iconSizeCss"
          [type]="'without-background'"
          icon="icon-linkedin"
          [overrideColor]="iconColor"
          (click)="navigateTo(linkedinLink)"
        ></app-rounded-icon-button>
      </div>
    }
    @if (instagramLink) {
      <div class="mr-2">
        <app-rounded-icon-button
          [size]="'sm'"
          [dimension]="iconSizeCss"
          [type]="'without-background'"
          icon="icon-instagram"
          [overrideColor]="iconColor"
          (click)="navigateTo(instagramLink)"
        ></app-rounded-icon-button>
      </div>
    }
    @if (tiktokLink) {
      <div class="mr-2">
        <app-rounded-icon-button
          [size]="'sm'"
          [dimension]="iconSizeCss"
          [type]="'without-background'"
          icon="icon-tiktok"
          [overrideColor]="iconColor"
          (click)="navigateTo(tiktokLink)"
        ></app-rounded-icon-button>
      </div>
    }
    @if (googleLink) {
      <div class="mr-2">
        <app-rounded-icon-button
          [size]="'sm'"
          [dimension]="iconSizeCss"
          [type]="'without-background'"
          icon="icon-google"
          [overrideColor]="iconColor"
          (click)="navigateTo(googleLink)"
        ></app-rounded-icon-button>
      </div>
    }
  </div>
</div>
